// Import dependencies
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import { initialiser } from '../../ramen-imports/utilitybelt';

class LogoList {
  constructor(config) {
    const { el, settings } = config;

    this.container = el;
    this.swiperInstance = null;
    this.settings = settings;
  }

  init = () => {
    this.initSwiper();
  };

  initSwiper = () => {
    // Add modules to settings
    this.settings.modules = [Navigation, Pagination];
    this.swiperInstance = new Swiper(this.container, this.settings);
  };
}

// Export component wrapped in initialiser utility
export default (settings) => initialiser(settings, LogoList);
